<template>
  <div class="menu-tabs">
    <a v-for="(item, index) in menuNavigations" :key="`menu-tab-item-${index}`"
       :class="['tab-item', { active: activeTab == item.labelDesktop }, { 'border-first': item.first }, { 'border-last': item.last}]"
       @click="goto(item)"
    >
      <i :class="['icon', item.icon]" />
      <span class="lg:hidden">{{ item.labelDesktop }}</span>
      <span class="hidden lg:block">{{ item.labelMobile }}</span>
    </a>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: ['data'],
  data() {
    return {
      menuNavigations: [],
      itemSelected: 'すべて'
    }
  },
  mounted() {
    if (this.data) {
      this.menuNavigations = _.cloneDeep(this.data)
    }
  },
  computed: {
    activeTab() {
      return this.itemSelected
    }
  },
  methods: {
    goto(nav) {
      this.itemSelected = nav.labelDesktop
      this.$emit('selectedCategory', this.itemSelected)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
